import {UnpackNestedValue} from 'react-hook-form/dist/types/form';
import {FormDataRaw} from './types';

export function buildZendeskTicketComment(
  values: UnpackNestedValue<FormDataRaw>,
  orderNumbers: string[],
) {
  let userDetails = ``;
  if (values.birthDate) {
    userDetails = `Date of birth: ${values.birthDate}`;
  }

  const orderNumbersText =
    orderNumbers.length > 0
      ? `
Order Numbers:
${orderNumbers.join('\n')}
`
      : '';

  const message = `Contact information:
${userDetails}${orderNumbersText}

Message:
${values.message}
`;

  return message;
}

export function buildZendeskTicketSubject(
  values: UnpackNestedValue<FormDataRaw>,
  orderNumbers: string[],
) {
  const reason = values.subject?.label ?? '';
  const appendix =
    orderNumbers.length > 0 ? orderNumbers.join(',') : values.email;

  return [reason, appendix].join(' - ');
}
